<template>
    <section>
        <div class="row justify-content-center">
            <div class="col col-sm-8 col-md-6 col-xl-4">
                <div class="card shadow-sm border-0 mb-3">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Change Password
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="save">
                            <div class="form-group">
                                <label class="font-weight-medium required">Password Lama</label>
                                <input v-model="form.old_password" type="password" class="form-control form-control-sm" placeholder="Password Lama" required />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Password Baru</label>
                                <input v-model="form.password" type="password" class="form-control form-control-sm" placeholder="Password Baru" required />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Konfirmasi Password Baru</label>
                                <input v-model="form.password_confirmation" type="password" class="form-control form-control-sm" placeholder="Konfirmasi Password Baru" required />
                            </div>
                            <div class="pt-3 text-center">
                                <button type="submit" class="btn btn-danger btn-sm px-5">
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <p class="font-weight-bold text-danger text-uppercase mb-0">Disclaimer:</p>
                <p class="font-weight-light text-danger">Password yang diganti akan terkirim ke email pengajar. Pastikan alamat email yang terdata sudah benar</p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "AccountPassword",
        data() {
            return {
                form: {
                    old_password: '',
                    password: '',
                    password_confirmation: ''
                }
            };
        },
        methods: {
            save() {
                this.axios.post(process.env.API_URL + '/user/password', this.form).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'account/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            }
        },
        mounted() {
            document.title = 'Change Password - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/employee/Password.vue